<template>
    <div :class="isResp">
        <rich-people-list-item :disabled="disabled" :count="count" @deleteResp="emitResp" :resp="resp" v-for="user in users"
                               :key="user.id"
                               :user="user"
        />

    </div>
</template>

<script>
    import RichPeopleListItem from "../a-elements/RichPeopleListItem";

    export default {
        name: "RichPeopleList",
        components: {RichPeopleListItem},
        props: {
            users: Array,
            resp: {
                type: Boolean,
                default: false
            },
            count: {
                type: Number,
                default: 0
            },
            disabled: Boolean
        },
        computed: {
            isResp() {
                if (this.resp) {
                    return 'list-resp'
                } else {
                    return 'list'
                }
            }
        },
        methods: {
            emitResp(model) {
                this.$emit('emitResp', model)
            }
        }
    }
</script>

<style scoped lang="scss">
    .list {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .list-resp {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
    }

    @include screen-m {
        .list {
            grid-template-columns: 1fr 1fr;
            gap: 24px;
        }
    }

</style>
